import styled, { css } from "styled-components";

export const InputWrapper = styled.div<{ $hasError?: boolean }>`
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid transparent;
  border-radius: 12px;
  padding: 12px 16px;
  transition: 0.3s ease;
  backdrop-filter: blur(6px);
  position: relative;

  ${({ $hasError, theme }) =>
    $hasError &&
    css`
      border-color: ${theme.THEME.error};
      box-shadow: 0 0 10px ${theme.THEME.error};
    `}

  &:focus-within {
    ${({ $hasError, theme }) =>
      $hasError
        ? css`
            border-color: ${theme.THEME.error};
            box-shadow: 0 0 8px ${theme.THEME.error};
          `
        : css`
            border-color: ${theme.THEME.neonBlue};
            box-shadow: 0 0 10px ${theme.THEME.neonBlue};
          `}
  }
`;

export const EmailInput = styled.input<{ $hasError?: boolean }>`
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 24}px;
  font-family: "Inter", sans-serif;

  &::placeholder {
    color: ${({ theme }) => theme.THEME.grayText};
    opacity: 0.7;
  }

  &:focus {
    outline: none;
  }

  &:-webkit-autofill,
  &:-webkit-autofill:hover,
  &:-webkit-autofill:focus {
    -webkit-box-shadow: 0 0 0px 1000px ${({ theme }) => theme.THEME.background}
      inset !important;
    -webkit-text-fill-color: ${({ theme }) => theme.THEME.white} !important;
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;

export const SuggestionBox = styled.ul`
  position: relative;
  background: ${({ theme }) => theme.THEME.background};
  border: 1px solid ${({ theme }) => theme.THEME.neonBlue};
  border-radius: 8px;
  z-index: 99;
  list-style: none;
  padding: 8px 0;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);

  max-height: 200px;
  overflow-y: auto;

  @media (max-height: 500px) {
    position: relative;
    top: auto;
    bottom: 8px;
    z-index: 1000;
  }
`;

export const SuggestionItem = styled.li`
  padding: 10px 16px;
  cursor: pointer;
  color: ${({ theme }) => theme.THEME.white};
  font-size: ${({ theme }) => theme.CONSTANTS.XR * 22}px;
  font-family: "Inter", sans-serif;

  strong {
    color: ${({ theme }) => theme.THEME.neonBlue};
  }

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }

  @media (min-width: 1025px) {
    font-size: ${({ theme }) => theme.CONSTANTS.XR * 6}px;
  }
`;
